<template>
  <div
    v-if="mq('small')"
    :class="['vehicle-selector-navigator', { 'element--is-loading': !context.initialized.value }]"
    role="group"
    tabindex="0">
    <ul v-if="context.initialized.value" class="vehicle-selector-navigator__list">
      <li v-for="node in filteredData" :key="node.code">
        <oie-vehicle-selector-action
          :context="context"
          :is-root-node="true"
          :node="node"
          :is-link="true"></oie-vehicle-selector-action>
      </li>
      <li v-if="hasOthers && !showOthers">
        <oie-base-action
          theme="outlined-black"
          size="large"
          aria-label="Expandera val"
          @click="showOthers = true">
          <template #iconPrepend>
            <oie-base-icon icon="add"></oie-base-icon>
          </template>
          {{ tStatic('showMoreLink') }}
        </oie-base-action>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent, computed, onMounted } from '@vue/composition-api'
import useNodeData from '@/composables/useNodeData'
import useFilteredNodeData from '@/composables/useFilteredNodeData'

export default defineComponent({
  setup() {
    const context = useNodeData()

    onMounted(() => {
      context.initializeNodeData()
    })

    return {
      context,
      ...useFilteredNodeData(computed(() => context.nodeData.value['0']), true)

    }
  }
})
</script>

<style lang="scss">
.vehicle-selector-navigator {
  @include container;
  background-color: color(background-gray-5);
  position: relative;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  min-height: 5rem
}

.vehicle-selector-navigator__list {
  @include reset-list;
  display: flex;
  gap: measure('quarter');
  flex-wrap: wrap;
}

</style>
